<template>
  <div id="app">
    <v-app>
      <v-card class="ma-10 pa-10">
        <v-card-title>投稿者用サインイン</v-card-title>
        <v-card-subtitle>
          リリースおめでとうございます🎉<br />
          このサイトにプロダクトを投稿して、友達に自慢しましょう！<br />
          ※GeekSalonの受講生・卒業生のみプロダクトの投稿が可能です。<br /><br />
          アカウントをお持ちでない方は<a @click="toSignUp">こちら</a>。
        </v-card-subtitle>
        <v-card-text>
          <v-text-field v-model="email" label="メールアドレス"> </v-text-field>
          <v-text-field type="password" v-model="password" label="パスワード">
          </v-text-field>
        </v-card-text>
        <v-card-subtitle
          ><a @click="toPassWordReset">パスワードを忘れた方</a>
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-actions class="signin-button__wrapper">
          <v-btn text v-on:click="submit" class="signin-button"
            >サインイン</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import firebase from "firebase"
export default {
  data() {
    return {
      email: "",
      password: "",
      success: false,
    }
  },
  methods: {
    toPassWordReset() {
      this.$router.push("password")
    },
    toSignUp() {
      this.$router.push("signup")
    },
    submit() {
      if (this.email === "" || this.email === null) {
        return alert("メールアドレスを入力してください")
      }
      if (this.password === "" || this.password === null) {
        return alert("パスワードを入力してください")
      }
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          this.$router.push("/form")
        })
        .catch((error) => {
          alert(error.message)
        })
    },
  },
}
</script>

<style scoped>
.signin-button {
  width: 100%;
}
</style>
